import { Routes } from '@angular/router';
import { AuthComponent } from "./pages/auth/auth.component";
import { LoginComponent } from "./pages/auth/login/login.component";
import { ResetPasswordComponent } from "./pages/auth/reset-password/reset-password.component";
import { ForgotPasswordComponent } from "./pages/auth/forgot-password/forgot-password.component";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { loginGuard } from "./core/guards/login.guard";
import { authGuard } from "./core/guards/auth.guard";
import { permissionGuard } from "./core/guards/permission.guard";
import { studentGuard } from "./core/guards/student.guard";
import { teacherGuard } from "./core/guards/teacher.guard";
import { HomeComponent } from "./pages/dashboard/home/home.component";
import { ProductsComponent } from './pages/dashboard/products/products.component';
import { OfficialPermissionsComponent } from './pages/dashboard/official-permissions/official-permissions.component';
import { ProofsComponent } from './pages/dashboard/proofs/proofs.component';
import { CourseCallsComponent } from './pages/dashboard/course-calls/course-calls.component';
import { PracticalClassesComponent } from './pages/dashboard/practical-classes/practical-classes.component';
import { CentersComponent } from './pages/dashboard/centers/centers.component';
import { UsersComponent } from './pages/dashboard/users/users.component';
import { AdministrationComponent } from './pages/dashboard/administration/administration.component';
import { ConfigurationsComponent } from './pages/dashboard/configurations/configurations.component';
import { HomeConfigurationComponent } from './pages/dashboard/configurations/home-configuration/home-configuration.component';
import {
  OfficeConfigurationComponent
} from "./pages/dashboard/configurations/office-configuration/office-configuration.component";
import {
  OfficialCenterConfigurationComponent
} from "./pages/dashboard/configurations/official-center-configuration/official-center-configuration.component";
import {
  RatesConfigurationComponent
} from "./pages/dashboard/configurations/rates-configuration/rates-configuration.component";
import {
  LicenseConfigurationComponent
} from "./pages/dashboard/configurations/license-configuration/license-configuration.component";
import { CompanyConfigurationComponent } from './pages/dashboard/configurations/company-configuration/company-configuration.component';
import { ContractsConfigurationComponent } from './pages/dashboard/configurations/contracts-configuration/contracts-configuration.component';
import { CourseConfigurationComponent } from './pages/dashboard/configurations/course-configuration/course-configuration.component';
import { ProofTypeConfigurationComponent } from './pages/dashboard/configurations/proof-type-configuration/proof-type-configuration.component';
import { VirtualClassroomConfigurationComponent } from './pages/dashboard/configurations/virtual-classroom-configuration/virtual-classroom-configuration.component';
import { VehicleConfigurationComponent } from './pages/dashboard/configurations/vehicle-configuration/vehicle-configuration.component';
import { UserDetailsComponent } from './pages/dashboard/users/user-details/user-details.component';
import { UsersHomeComponent } from './pages/dashboard/users/users-home/users-home.component';
import { ExaminerConfigurationComponent } from './pages/dashboard/configurations/examiner-configuration/examiner-configuration.component';
import { ProofCentersConfigurationComponent } from './pages/dashboard/configurations/proof-centers-configuration/proof-center-configuration.component';
import { ProofDefinitionConfigurationComponent } from './pages/dashboard/configurations/proof-definition-configuration/proof-definition-configuration.component';
import { PriceListConfigurationComponent } from './pages/dashboard/configurations/price-list-configuration/price-list-configuration.component';
import { TemplateConfigurationComponent } from './pages/dashboard/configurations/template-configuration/template-configuration.component';
import { TemplateHomeComponent } from './pages/dashboard/configurations/template-configuration/template-home/template-home.component';
import { TemplateDetailsComponent } from './pages/dashboard/configurations/template-configuration/template-details/template-details.component';
import { CourseHomeComponent } from './pages/dashboard/course-calls/course-call-home/course-call-home.component';
import { CourseDetailsComponent } from './pages/dashboard/course-calls/course-call-details/course-call-details.component';
import { ProofHomeComponent } from './pages/dashboard/proofs/proof-home/proof-home.component';
import { ProofDetailsComponent } from './pages/dashboard/proofs/proof-details/proof-details.component';
import { ProductHomeComponent } from './pages/dashboard/products/product-home/product-home.component';
import { ProductDetailsComponent } from './pages/dashboard/products/product-details/product-details.component';
import { MessagesComponent } from './pages/dashboard/messages/messages.component';
import { CuadranteComponent } from './pages/dashboard/practical-classes/cuadrante/cuadrante.component';
import { CalendarioComponent } from './pages/dashboard/practical-classes/calendario/calendario.component';
import { GeneradorComponent } from './pages/dashboard/practical-classes/generador/generador.component';
import { GestionMasivaComponent } from './pages/dashboard/practical-classes/gestion-masiva/gestion-masiva.component';
import { PracticeSkillsConfigurationComponent } from './pages/dashboard/configurations/practice-skills-configuration/practice-skills-configuration.component';
import { BankDetailsComponent } from './pages/dashboard/administration/entity-details/bank-details/bank-details.component';
import { MovementDetailsComponent } from './pages/dashboard/administration/entity-details/movement-details/movement-details.component';
import { InvoiceDetailsComponent } from './pages/dashboard/administration/entity-details/invoice-details/invoice-details.component';
import { ComunicationsComponent } from './pages/dashboard/comunications/comunications.component';
import { EmailDetailsComponent } from './pages/dashboard/comunications/components/email-details/email-details.component';
import { UnifiedAdminComponent } from './pages/dashboard/administration/unified-admin/unified-admin.component';

export const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
    data: { breadcrumb: null },
    children: [
      { path: 'inicio', component: HomeComponent, data: { breadcrumb: null } },
      {
        path: 'productos', component: ProductsComponent, canActivate: [permissionGuard], data: { breadcrumb: 'Productos', permission: 'products.access' }, children: [
          { path: '', component: ProductHomeComponent, data: { breadcrumb: null } },
          { path: ':id', component: ProductDetailsComponent, data: { breadcrumb: null } }
        ]
      },
      { path: 'permisos', component: OfficialPermissionsComponent, data: { breadcrumb: 'Permisos' } },
      {
        path: 'convocatorias', component: CourseCallsComponent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Convocatoria de Cursos', permission: 'courses.access' },
        children: [
          { path: '', component: CourseHomeComponent, data: { breadcrumb: null } },
          { path: ':id', component: CourseDetailsComponent, data: { breadcrumb: null } }
        ]
      },
      {
        path: 'pruebas', component: ProofsComponent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Convocatoria de Exámenes', permission: 'proofs.access' },
        children: [
          { path: '', component: ProofHomeComponent, data: { breadcrumb: null } },
          { path: ':id', component: ProofDetailsComponent, data: { breadcrumb: null } }
        ]
      },
      {
        path: 'clasesPracticas',
        component: PracticalClassesComponent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Clases Prácticas', permission: 'practices.access' },
        children: [
          { path: '', redirectTo: 'cuadrante', pathMatch: 'full' },
          { path: 'cuadrante', component: CuadranteComponent, data: { breadcrumb: 'Cuadrante' } },
          { path: 'calendario', component: CalendarioComponent, data: { breadcrumb: 'Calendario' } },
          { path: 'generador', component: GeneradorComponent, data: { breadcrumb: 'Generador' } },
          { path: 'gestionMasiva', component: GestionMasivaComponent, data: { breadcrumb: 'Gestión masiva' } }
        ]
      },
      { path: 'centros', component: CentersComponent, data: { breadcrumb: 'Centros' } },
      { path: 'comunicaciones', component: ComunicationsComponent, canActivate: [permissionGuard], data: { breadcrumb: 'Comunicaciones', permission: 'communications.access' } },
      { path: 'email/show/:id', component: EmailDetailsComponent, data: { breadcrumb: 'Detalles del Email' } },
      {
        path: 'email-templates',
        loadComponent: () => import('./pages/dashboard/comunications/components/email-template/email-template.component').then(m => m.EmailTemplateComponent),
        data: { breadcrumb: 'Plantillas de Email' }
      },
      {
        path: 'usuarios',
        component: UsersComponent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Usuarios', permission: 'students.access' },
        children: [
          { path: '', component: UsersHomeComponent, data: { breadcrumb: null } },
          { path: ':id', component: UserDetailsComponent, data: { breadcrumb: null } }
        ]
      },
      {
        path: 'administracion',
        component: AdministrationComponent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Administración', permission: 'administration.access' },
        children: [
          {
            path: '',
            component: UnifiedAdminComponent,
            data: { breadcrumb: null }
          },
          // Rutas de detalle para cada entidad
          {
            path: 'banks/:id',
            component: BankDetailsComponent,
            data: { breadcrumb: 'Detalles del Banco' }
          },
          {
            path: 'movements/:id',
            component: MovementDetailsComponent,
            data: { breadcrumb: 'Detalles del Movimiento' }
          },
          {
            path: 'invoices/:id',
            component: InvoiceDetailsComponent,
            data: { breadcrumb: 'Detalles de la Factura' }
          },
          // TODO: Crear componentes de detalle para:
          // - cash-closures/:id → CashClosureDetailsComponent
          // - chart-of-accounts/:id → ChartOfAccountDetailsComponent
          // Redirects para backward compatibility
          {
            path: 'bancos',
            redirectTo: '?entity=banks',
            pathMatch: 'full'
          },
          {
            path: 'bancos/:id',
            redirectTo: 'banks/:id',
            pathMatch: 'full'
          },
          {
            path: 'movimientos',
            redirectTo: '?entity=movements',
            pathMatch: 'full'
          },
          {
            path: 'movimientos/:id',
            redirectTo: 'movements/:id',
            pathMatch: 'full'
          }
        ]
      },
      { path: 'mensajes', component: MessagesComponent, canActivate: [permissionGuard], data: { breadcrumb: 'Mensajes', permission: 'messages.access' } },
      {
        path: 'configuracion',
        component: ConfigurationsComponent,
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Configuración', permission: 'configuration.access' },
        children: [
          {
            path: '',
            component: HomeConfigurationComponent,
            data: { breadcrumb: null }
          },
          {
            path: 'sucursales',
            component: OfficeConfigurationComponent,
            data: { breadcrumb: 'Sucursales' }
          },
          {
            path: 'centros-oficiales',
            component: OfficialCenterConfigurationComponent,
            data: { breadcrumb: 'Centros Oficiales' }
          },
          {
            path: 'tasas-oficiales',
            component: RatesConfigurationComponent,
            data: { breadcrumb: 'Tasas Oficiales' }
          },
          {
            path: 'permisos-oficiales',
            component: LicenseConfigurationComponent,
            data: { breadcrumb: 'Permisos Oficiales' }
          },
          {
            path: 'sociedades',
            component: CompanyConfigurationComponent,
            data: { breadcrumb: 'Sociedades' }
          },
          {
            path: 'cursos',
            component: CourseConfigurationComponent,
            data: { breadcrumb: 'Cursos' }
          },
          {
            path: 'tipos-pruebas',
            component: ProofTypeConfigurationComponent,
            data: { breadcrumb: 'Subtipos de Examen' }
          },
          {
            path: 'aulas-virtuales',
            component: VirtualClassroomConfigurationComponent,
            data: { breadcrumb: 'Aulas Virtuales' }
          },
          {
            path: 'vehiculos',
            component: VehicleConfigurationComponent,
            data: { breadcrumb: 'Vehículos' }
          },
          {
            path: 'examinadores',
            component: ExaminerConfigurationComponent,
            data: { breadcrumb: 'Examinadores' }
          },
          {
            path: 'centros-de-pruebas',
            component: ProofCentersConfigurationComponent,
            data: { breadcrumb: 'Centros de Pruebas' }
          },
          {
            path: 'definiciones-pruebas',
            component: ProofDefinitionConfigurationComponent,
            data: { breadcrumb: 'Tipos de Examen' }
          },
          {
            path: 'tarifas',
            component: PriceListConfigurationComponent,
            data: { breadcrumb: 'Tarifas' }
          },
          {
            path: 'contratos',
            component: ContractsConfigurationComponent,
            data: { breadcrumb: 'Contratos' }
          },
          {
            path: 'plantillas',
            component: TemplateConfigurationComponent,
            data: { breadcrumb: 'Plantillas de Contrato' },
            children: [
              { path: '', component: TemplateHomeComponent, data: { breadcrumb: null } },
              { path: ':id', component: TemplateDetailsComponent, data: { breadcrumb: 'Detalle de Plantilla' } }
            ]
          },
          {
            path: 'habilidades-practica',
            component: PracticeSkillsConfigurationComponent,
            data: { breadcrumb: 'Habilidades de Práctica' }
          },
        ]
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'inicio'
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'inicio'
      }
    ]
  },
  {
    path: 'alumno',
    canActivate: [studentGuard],
    loadComponent: () =>
      import('./pages/student/student-layout/student-layout.component').then(m => m.StudentLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'inicio' },
      {
        path: 'inicio',
        loadComponent: () =>
          import('./pages/student/student-dashboard/student-dashboard.component').then(m => m.StudentDashboardComponent),
      },
      {
        path: 'calendario',
        loadComponent: () =>
          import('./pages/student/student-calendar/student-calendar.component').then(m => m.StudentCalendarComponent),
      },
      {
        path: 'aula',
        loadComponent: () =>
          import('./pages/student/student-classroom/student-classroom.component').then(m => m.StudentClassroomComponent),
      },
      {
        path: 'documentos',
        loadComponent: () =>
          import('./pages/student/student-documents/student-documents.component').then(m => m.StudentDocumentsComponent),
      },
      { path: '**', redirectTo: 'inicio' },
    ],
  },
  {
    path: 'profesor',
    canActivate: [teacherGuard],
    loadComponent: () =>
      import('./pages/teacher/teacher-layout/teacher-layout.component').then(m => m.TeacherLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'practicas' },
      {
        path: 'practicas',
        loadComponent: () =>
          import('./pages/dashboard/practical-classes/cuadrante/cuadrante.component').then(m => m.CuadranteComponent),
      },
      {
        // Reutiliza el modulo de Usuarios (ya filtrado a los alumnos del profesor
        // y en solo lectura). La tabla navega relativo -> se queda en /profesor.
        path: 'alumnos',
        component: UsersComponent,
        children: [
          { path: '', component: UsersHomeComponent },
          { path: ':id', component: UserDetailsComponent },
        ],
      },
      {
        // Conv. cursos: mismos componentes; el backend filtra a las suyas.
        path: 'convocatorias',
        component: CourseCallsComponent,
        children: [
          { path: '', component: CourseHomeComponent },
          { path: ':id', component: CourseDetailsComponent },
        ],
      },
      {
        // Conv. examenes: mismos componentes; el backend filtra a los suyos.
        path: 'pruebas',
        component: ProofsComponent,
        children: [
          { path: '', component: ProofHomeComponent },
          { path: ':id', component: ProofDetailsComponent },
        ],
      },
      { path: '**', redirectTo: 'practicas' },
    ],
  },
  {
    path: '',
    component: AuthComponent,
    canActivate: [loginGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'recuperar-contrasena/:token/:email',
        component: ResetPasswordComponent
      },
      {
        path: 'olvidaste-tu-contrasena',
        component: ForgotPasswordComponent
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'login'
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
